import React, { useState, useRef } from "react";
import { Button } from "@leafly-com/frontend-components";
import { useDispatch, useSelector } from "react-redux";

import { trackMenuEvent } from "utils/trackEvent";
import { getCountryCode } from "utils/getCountryCode";
import { AddToBagModal } from "./AddToBagModal";
import {
  LoadCartAction,
  RESERVATION_LOAD_CART,
} from "redux/reducers/reservation";
import { getCartId } from "redux/selectors/reservation";

type AddToBagButtonProps = {
  as?: any;
  defaultVariantId: number;
  icon?: string;
  menuItemId: number;
};

export const AddToBagButton: React.FC<AddToBagButtonProps> = ({
  menuItemId,
  defaultVariantId,
  as: Element = Button,
  ...props
}) => {
  const cartId = useSelector(getCartId)!; // You will have a cart id by the time you open the modal
  const countryCode = useSelector(getCountryCode);
  const dispatch = useDispatch();
  const [viewingModal, setViewingModal] = useState(false);
  const buttonRef = useRef(null);

  const addToBag = (e: any) => {
    trackMenuEvent(
      "Menu Card ATB Button",
      "Menu Card ATB Modal Open",
      menuItemId,
      null,
      null,
      null
    );
    e.preventDefault();
    e.stopPropagation();
    setViewingModal(true);
  };

  return (
    <>
      <Element {...props} onClick={addToBag} ref={buttonRef} />
      {viewingModal && (
        <AddToBagModal
          cartId={cartId}
          countryCode={countryCode}
          variantId={defaultVariantId}
          onCartFetch={(cart) => {
            dispatch<LoadCartAction>({
              type: RESERVATION_LOAD_CART,
              cart,
            });
          }}
          onDismissed={() => {
            setViewingModal(false);
          }}
          returnFocusRef={buttonRef}
        />
      )}
    </>
  );
};
